import * as angular from 'angular';
import { IRequestService } from '../../../services';
import { ResultsFormat } from '../../../components/groupStepDetails/groupStepDetails.chart';

export interface IGroupResultsService {
    getResults(groupGuid: string, beginDateTime: string, endDateTime: string, force?:boolean): angular.IPromise<ResultsFormat[]>;
}

export class GroupResultsService implements IGroupResultsService {
    static serviceId = 'groupResultsService';

    static $inject = ['requestService'];
    constructor(private _requestService: IRequestService) {
    }

    getResults(groupGuid: string, beginDateTime: string, endDateTime: string, force:boolean=false): angular.IPromise<ResultsFormat[]> {
        if(!!force){
            this._requestService.cleanCacheAtV1('GroupResults/ResultsStatus', { groupGuid, beginDateTime, endDateTime });
        }
        return this._requestService.getAtV1('GroupResults/ResultsStatus', { groupGuid, beginDateTime, endDateTime })
            .then((data: any[]) => {
                data.forEach(d => d.results.forEach(r => r.timeStamp = new Date(r.timeStamp)));
                return data;
            });
    }
}